function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2158_3893)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M42.6667 29.3335C47.0934 29.3335 50.6401 25.7602 50.6401 21.3335C50.6401 16.9068 47.0934 13.3335 42.6667 13.3335C38.2401 13.3335 34.6667 16.9068 34.6667 21.3335C34.6667 25.7602 38.2401 29.3335 42.6667 29.3335ZM21.3334 29.3335C25.7601 29.3335 29.3067 25.7602 29.3067 21.3335C29.3067 16.9068 25.7601 13.3335 21.3334 13.3335C16.9067 13.3335 13.3334 16.9068 13.3334 21.3335C13.3334 25.7602 16.9067 29.3335 21.3334 29.3335ZM21.3334 34.6668C15.1201 34.6668 2.66675 37.7868 2.66675 44.0002V48.0002C2.66675 49.4668 3.86675 50.6668 5.33341 50.6668H37.3334C38.8001 50.6668 40.0001 49.4668 40.0001 48.0002V44.0002C40.0001 37.7868 27.5467 34.6668 21.3334 34.6668ZM42.6667 34.6668C41.8934 34.6668 41.0134 34.7202 40.0801 34.8002C40.1334 34.8268 40.1601 34.8802 40.1867 34.9068C43.2267 37.1202 45.3334 40.0802 45.3334 44.0002V48.0002C45.3334 48.9335 45.1467 49.8402 44.8534 50.6668H58.6667C60.1334 50.6668 61.3334 49.4668 61.3334 48.0002V44.0002C61.3334 37.7868 48.8801 34.6668 42.6667 34.6668Z",
  fill: "#9B9B9B"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2158_3893"
}, /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  fill: "white"
})));

function SvgPeopleIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/people-icon.570a9c6d.svg";
export { ForwardRef as ReactComponent };